export interface ResolvedColors {
  fillColor: string;
  strokeColor: string;
  textColor: string | undefined;
}

// No hex fallbacks: variables.css is always loaded, so a fallback can never fire
// but can silently go stale. The previous `#7F7B7C` fallback on PAST_TEXT had
// become the pre-fix value of text-secondary, which fails AA at 4.18:1.
const PAST_FILL = 'var(--color-surface-tertiary)';
const PAST_STROKE = 'var(--color-border-primary)';
const PAST_TEXT = 'var(--color-text-secondary)';

const EMPTY_FILL = 'var(--color-surface-primary)';

/**
 * Resolves display colors for a Gantt cell based on temporal and booking state.
 *
 * Rules:
 * - Past week (regardless of patient count) → uniform gray
 * - Future/current week with 0 patients → white fill, original stroke
 * - Future/current week with patients > 0 → original colors
 */
export function resolveCellColors(
  baseFillColor: string,
  baseStrokeColor: string,
  isPast: boolean,
  patientCount: number
): ResolvedColors {
  if (isPast) {
    return {
      fillColor: PAST_FILL,
      strokeColor: PAST_STROKE,
      textColor: PAST_TEXT
    };
  }

  if (patientCount === 0) {
    return {
      fillColor: EMPTY_FILL,
      strokeColor: baseStrokeColor,
      textColor: undefined
    };
  }

  return {
    fillColor: baseFillColor,
    strokeColor: baseStrokeColor,
    textColor: undefined
  };
}
